import type { App } from 'vue'
export const install = (app: App) => {
  app.directive('hoist', (el) => {
    if (el.tagName === 'TEMPLATE')
      el.replaceWith(el.content)

    else
      el.replaceWith(...el.children)
  })
}
